<!----
    Author: hjlee
    Description:
        로그인 모달
---->
<template>
  <div class="login-modal">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-md-12">
          <div class="card-group">
            <div class="card p-4">
              <div class="card-body">
                <h1>
                  {{ $t('login_modal.title.login') }}
                </h1>
                <p class="text-muted">
                  {{ $t('login_modal.title.sign_in') }}
                </p>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="icon-user" />
                    </span>
                  </div>
                  <input
                    ref="username"
                    v-model="userId"
                    class="form-control"
                    type="text"
                    :placeholder="$t('login_modal.placeholder.username')"
                    @keyup="onKeyupUsername"
                  >
                </div>
                <div class="input-group mb-4">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="icon-lock" />
                    </span>
                  </div>
                  <input
                    ref="password"
                    v-model="userPwd"
                    class="form-control"
                    type="password"
                    :placeholder="$t('login_modal.placeholder.password')"
                    @keyup="onKeyupPassword"
                  >
                </div>
                <div class="row">
                  <div class="col-md-6 col-sm-12">
                    <button :class="{'btn': true, 'btn-primary': true, 'btn-start-with-l': configs && configs.system_id && configs.system_id.indexOf('l') === 0, 'px-4': true}" type="button" :disabled="!userId || !userPwd" @click="login">
                      {{ $t('login_modal.button.login') }}
                    </button>
                  </div>
                  <div class="col-md-6 col-sm-12 text-right">
                    <button class="btn btn-link px-0 btn-forgot-password" type="button" @click="showForgotPasswordModal">
                      {{ $t('login_modal.button.forgot_password') }}
                    </button>
                  </div>
                </div>
              </div>
              <locale-selector />
            </div>
            <div :class="{'card': true, 'text-white': true, 'bg-primary': true, 'bg-start-with-l': configs && configs.system_id && configs.system_id.indexOf('l') === 0, 'p-4': true}">
              <div class="card-body text-center">
                <div>
                  <h2>
                    {{ $t('login_modal.title.sign_up') }}
                  </h2>
                  <p>
                    {{ $t('login_modal.text.sign_up') }}
                  </p>
                  <button :class="{'btn': true, 'btn-primary': true, 'btn-start-with-l': configs && configs.system_id && configs.system_id.indexOf('l') === 0, 'active': true, 'mt-3': true}" type="button" @click="showSignUpModal">
                    {{ $t('login_modal.button.sign_up') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <forgot-password-modal ref="forgotPasswordModal" />
    <sign-up-modal ref="signUpModal" />
    <change-password-modal ref="changePasswordModal" :user-id="userIdInserted" />
  </div>
</template>

<script>
import LocaleSelector from '~/components/common/LocaleSelector'
import ForgotPasswordModal from './ForgotPasswordModal'
import SignUpModal from './SignUpModal'
import ChangePasswordModal from './ChangePasswordModal'

export default {
  components: {
    SignUpModal,
    ForgotPasswordModal,
    LocaleSelector,
    ChangePasswordModal
  },
  data: function() {
    return {
      userIdInserted: '',
      userId: '',
      userPwd: ''
    }
  },
  methods: {
    showForgotPasswordModal: function() {
      this.$refs.forgotPasswordModal.email = ''
      this.$refs.forgotPasswordModal.showModal('modalRef')
    },
    showSignUpModal: function() {
      this.$refs.signUpModal.showModal('modalRef')
    },
    showModal: function() {
      $(this.$el).fadeIn()
      $('body').css('overflow', 'hidden')
    },
    hideModal: function() {
      $(this.$el).fadeOut()
      $('body').css('overflow', 'auto')
    },
    login: function() {
      this.userIdInserted = this.userId
      this.$auth
        .loginWith('jwt', {
          data: {
            userId: this.userId,
            userPwd: this.userPwd,
            siteId: process.env.siteId
          }
        })
        .then(response => {
          if (window._loadedPushToken && window._onPushTokenLoaded) {
            window._onPushTokenLoaded(window._loadedPushToken)
          }
          this.hideModal('modalRef')
          this.userId = ''
          this.userPwd = ''
          this.$toast.info(this.$t('auth.notification.signed_in'))
          if (this.isCouponTicketUser()) {
            this.openLink('/offline_meeting_ticket')
          }
        })
        .catch(error => {
          if (error.response && error.response.data) {
            if (error.response.data.resultCode === 'password_expired_1') {
              this.$refs.changePasswordModal.showModal('modalRef')
            }
          }
        })
    },
    onKeyupUsername(e) {
      if (e.keyCode === 13) {
        this.$refs.password.focus()
      }
    },
    onKeyupPassword(e) {
      if (e.keyCode === 13) {
        this.login()
      }
    }
  }
}
</script>

<style scoped>
.btn-forgot-password {
  word-break: keep-all;
}
.login-modal {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1030;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: white;
  display: none;
  padding-top: 80px;
  padding-bottom: 80px;
}

.btn-start-with-l,
.bg-start-with-l {
  background-color: #5c9c9c !important;
}

@media (max-width: 960px) {
  .container {
    width: 100%;
  }
}

@media (max-width: 540px) {
  .login-modal {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>
